import React from "react";
import Button from "@mui/material/Button";
import { useState, useEffect, useRef } from "react";
import axios from "../../../utils/fvAxios";
import TextareaAutosize from "@mui/material/TextareaAutosize";
import DialogActions from "@mui/material/DialogActions";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import { type } from "@testing-library/user-event/dist/type";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";

import Typography from "@mui/material/Typography";
import MuiSelect from "@mui/material/Select";
import { Chip, Checkbox } from "@mui/material";
import ListItemText from "@mui/material/ListItemText";
import { Box } from "@mui/material";
import { ToastContainer, toast } from "react-toastify";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";

export default function LocationContextEdit({
  PQID,
  SetOpen,
  REFRESH,
  REFREE,
  UNITID,
  BUSUNITSITNAME,
  UNITSITEID,
  Close,

  SEC,
  SUB,
  SECTIONTYPE,
  SUBSECTYPCON,
  PqClients,
  ClientTemplate,
  ID,
  ClientBuUnitID,
  ClientBuUnitSiteID,
  Comments,
  CliId,
  PqSitesId,
  FirstClient,
  isERITemplate,
  LocationSectionReset
}) {
  const [ClientId, setClientId] = useState(
    CliId ?? (PqClients?.length > 1 ? PqClients[0]?.key : FirstClient)
  );

  const [BusinessUnitsId, setBusinessUnitsId] = useState(ClientBuUnitID);
  const [BusinessUnitSites, setBusinessUnitSites] = useState([]);
  const [BusinessUnits, setBusinessUnits] = useState([]);

  const [Regions, setRegions] = useState([]);
  const [RegionsId, setRegionsId] = useState([]);
  const [EditRegionsId, setEditRegionsId] = useState(ClientBuUnitSiteID);
  const [Comment, setComment] = useState(Comments);

  const [Trig, setTrig] = useState(false);
  const ITEM_HEIGHT = 50;
  const ITEM_PADDING_TOP = 8;
  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 5 + ITEM_PADDING_TOP,
        width: 200,
      },
    },
  };

  const SelectClientHandle = (e) => {
    setClientId(e);
  };

  useEffect(() => {
    const CliId = PqClients.length > 1 ? ClientId : FirstClient;
    if (!CliId > 0) return;

    setRegions([]);
    setRegionsId([]);
    setSelectAllChecked(false);
    if (!BusinessUnitsId > 0) {
    } else getClientBusinessUnitSites(BusinessUnitsId);
  }, [BusinessUnitsId]);

  useEffect(() => {
    const CliId = PqClients.length > 1 ? ClientId : FirstClient;
    if (!CliId > 0) return;
    (async () => {
      const resp = await getClientBusinessUnits();

      setBusinessUnits(resp?.data?.data);
      if (ID == 1) {
        setBusinessUnitsId(resp?.data?.data[0]?.key);
      }
    })();
  }, [ClientId]);

  const getClientBusinessUnits = async () => {
    let CliId = isERITemplate ? ClientId : FirstClient;

    const resp = await axios.get(
      "Prequalification/GetPqClientBusinessUnits?clientId=" + CliId
    );
    return resp;
  };

  const getClientBusinessUnitSites = (_BusinessUnitsId) => {
    const businessUnitsId = _BusinessUnitsId ?? BusinessUnitsId;
    setBusinessUnitSites([]); //Empty first
    const isNew = ID === 1;

    axios
      .get(
        `Prequalification/GetClientBusinessUnitSites?buId=${businessUnitsId}&pqId=${PQID}&isEdit=${!isNew}`
      )
      .then((resp) => {
        setBusinessUnitSites(resp?.data?.data);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const BusinesshandleChanged = (e) => {
    setBusinessUnitsId(e);
    // setTrig(!Trig);
  };

  const RegionshandleEditChanged = (e) => {
    setEditRegionsId(e);
  };

  const [selectAllChecked, setSelectAllChecked] = useState(false);
  // const [selectValue1, setSelectValue1] = useState([]);

  const handleSelectAllChange = (event) => {
    const { checked } = event.target;
    setSelectAllChecked(checked);

    if (checked) {
      // If "Select All" is checked, set all clients
      const allClientValues = BusinessUnitSites?.filter(
        (val) => val.isSelected === false
      );
      setRegions(allClientValues);
      setRegionsId(allClientValues);
    } else {
      // If "Select All" is unchecked, clear the selection
      setRegions([]);
      setRegionsId([]);
    }
  };

  const handleSelectAllClicked = (event) => {
    const checked = !selectAllChecked;
    setSelectAllChecked(checked);

    if (checked) {
      // If "Select All" is checked, set all clients
      const allClientValues = BusinessUnitSites?.filter(
        (val) => val.isSelected === false
      );
      setRegions(allClientValues);
      setRegionsId(allClientValues);
    } else {
      // If "Select All" is unchecked, clear the selection
      setRegions([]);
      setRegionsId([]);
    }
  };

  const menuListRef = useRef(null);
  const handleMenuOpen = () => {
    scrollToTopOfOtions();
  };
  const scrollToTopOfOtions = () => {
    setTimeout(() => {
      if (menuListRef.current) {
        const children = menuListRef.current.children;
        if (children.length >= 2) {
          const secondLastOption = children[children.length - 2];
          if (secondLastOption) {
            secondLastOption.scrollTop = 0;
          }
        }
      }
    }, 5);
  };


  const handleRegionChange = (value, e, node) => {
    const updatedSelected = value.includes("selectAll")
      ? value.filter((val) => val !== "selectAll")
      : value;
    const latestCheckedOption = value.find(
      (option) => !Regions.includes(option)
    );

    const currentOption = node?.props?.value;

    if (currentOption == "selectAll") {

      const checked = latestCheckedOption == "selectAll"

      if (checked && !selectAllChecked) {
        // If "Select All" is checked, set all clients
        const allClientValues = BusinessUnitSites?.filter(
          (val) => val.isSelected === false
        );
        setRegions(allClientValues);
        setRegionsId(allClientValues);
        setSelectAllChecked(true);
        scrollToTopOfOtions();
      } else {
        setSelectAllChecked(false);
        // If "Select All" is unchecked, clear the selection
        setRegions([]);
        setRegionsId([]);
      }
    } else {
      setRegions(value);
      setRegionsId(value);
    }
  };

  const CommentHandle = (e) => {
    setComment(e);
  };
  const [Dis, setDis] = useState(false);
  const AddLocation = () => {
    setDis(true);
    if (ID == 1) {
      if (BusinessUnitsId != "" && Regions != "" && Regions[0] != "selectAll") {
        const buSites = Regions?.map((r) => {
          return {
            businessUnitSiteId: r.businessUnitSiteId,
            siteName: r.siteName,
            isSelected: true,
            isChecked: true,
          };
        });
        const location = {
          prequalificationid: +PQID,
          clientId: ClientId,
          pqSiteId: 0,
          businessUnitId: BusinessUnitsId,
          businessUnitSiteId: 0,
          comments: Comment,
          buSites: buSites,
        };

        axios.post("Prequalification/AddPqSites", location).then((res) => {
          if (res?.data?.data == "Success") {
            toast.success(res?.data?.data, {
              position: "top-right",
              autoClose: 4000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "light",
            });
            REFRESH(REFREE);
            Close();
            LocationSectionReset();
            setTimeout(() => {
              setDis(false);
            }, 5000)
          } else {
            toast.error(res?.data?.data, {
              position: "top-right",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "light",
            });
            setTimeout(() => {
              setDis(false);
            }, 5000)
            SetOpen();
          }
        });
      } else {
        toast.error("Please select atleast one Business Unit Site", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
        SetOpen();
        setTimeout(() => {
          setDis(false);
        }, 5000)
      }
    } else {
      const location = {
        prequalificationid: +PQID,
        clientId: ClientId,
        pqSiteId: PqSitesId,
        businessUnitId: BusinessUnitsId,
        businessUnitSiteId: EditRegionsId,
        comments: Comment,
        buSites: [],
      };

      axios.post("Prequalification/UpdatePqSite", location)?.then((res) => {
        if (res?.data?.data == "Success") {
          toast.success(res?.data?.data, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
          REFRESH(REFREE);
          // LocationSectionReset();
          setTimeout(() => {
            setDis(false);
          }, 5000)
          Close();
        } else {
          toast.error(res?.data?.data, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
          setTimeout(() => {
            setDis(false);
          }, 5000)
        }
      });
    }

  };

  return (
    <div>
      <ToastContainer />

      {isERITemplate && (
        <h5 className="d-none">
          Note: Only one client's location can be added and saved at a time. To
          add another client's location, click on Add New button again and
          select the client and location.
        </h5>
      )}
      <div className="">
        {isERITemplate && ID === 1 ? (
          <>
            <div>
              {/* <div style={{ display: PqClients.length > 1 ? "block" : "none" }}> */}
              <span style={{ color: "#3E4A62" }}>
                Select Business Unit
                <small style={{ color: "red" }}>*</small>
              </span>
              <br />
              <Select
                sx={{
                  "& legend": { display: "none" },
                  "& fieldset": { top: 0 },
                  width: "320px",
                }}
                labelId="demo-multiple-name-label"
                id="demo-multiple-name"
                size="small"
                value={ClientId || ""}
                onChange={(e) => SelectClientHandle(e.target.value)}
                // input={<OutlinedInput label="SelectClient" />}
                MenuProps={MenuProps}
              >
                {PqClients?.map((item, index) => (
                  <MenuItem key={index} title={item.value} value={item.key}>
                    {item.value}
                  </MenuItem>
                ))}
              </Select>
            </div>

            <span style={{ color: "#3E4A62" }}>
              Location(s)/Project(s)<small style={{ color: "red" }}>*</small>
            </span>
            <br />

            <Select
              size="small"
              onOpen={handleMenuOpen}
              sx={{
                "& legend": { display: "none" },
                "& fieldset": { top: 0 },
                width: "320px",
              }}
              labelId="demo-multiple-checkbox-label"
              id="demo-multiple-checkbox"
              multiple
              value={Regions || ""}
              onChange={(e, node) => handleRegionChange(e.target.value, e, node)}
              renderValue={(selected) => {
                if (selected.length === 0) {
                  return "Select Region";
                }
                return (
                  <Box sx={{ flexWrap: "wrap", gap: 0.5, overflowX: "hidden" }}>
                    {selected?.map((value, i) => (
                      <Chip
                        sx={{ marginRight: "10px" }}
                        key={i}
                        label={value.siteName}
                      />
                    ))}
                  </Box>
                );
              }}
              MenuProps={{
                ref: menuListRef,
                PaperProps: MenuProps.PaperProps,
              }
              }
            >
              <MenuItem
                value="selectAll"
                hidden={
                  BusinessUnitSites
                    ? BusinessUnitSites.filter(
                      (bus) => bus.isSelected === false
                    )?.length === 0
                    : true
                }
              >
                <Checkbox
                  checked={selectAllChecked}
                  onChange={handleSelectAllChange}
                />
                <ListItemText primary="Select All" />
              </MenuItem>
              {BusinessUnitSites?.map((name, i) => (
                <MenuItem
                  key={i}
                  value={name}
                  hidden={name.isSelected === true}
                  title={name.siteName}
                >
                  <Checkbox checked={Regions?.includes(name)} />
                  <ListItemText primary={name.siteName} />
                </MenuItem>
              ))}
            </Select>
          </>
        ) : (
          <>
            <div>
              <span style={{ color: "#3E4A62" }}>
                Business Unit<small style={{ color: "red" }}>*</small>
              </span>
              <br />

              <Select
                sx={{
                  "& legend": { display: "none" },
                  "& fieldset": { top: 0 },
                  width: "320px",
                }}
                labelId="demo-multiple-name-label"
                value={BusinessUnitsId || ""}
                id="demo-multiple-name"
                size="small"
                onChange={(e) => BusinesshandleChanged(e.target.value)}
                MenuProps={MenuProps}
              >
                {BusinessUnits?.map((item, index) => (
                  <MenuItem key={index} title={item.value} value={item.key}>
                    {item.value}
                  </MenuItem>
                ))}
              </Select>
            </div>

            <span style={{ color: "#3E4A62" }}> {ID === 1 ? "Location(s)/Project(s)" : "Business Unit Site"}</span>
            <br />

            {ID === 1 ? (
              <Select
                onOpen={handleMenuOpen}
                size="small"
                sx={{
                  "& legend": { display: "none" },
                  "& fieldset": { top: 0 },
                  width: "320px",
                }}
                labelId="demo-multiple-checkbox-label"
                id="demo-multiple-checkbox"
                multiple
                value={Regions || ""}
                onChange={(e, node) => handleRegionChange(e.target.value, e, node)}
                renderValue={(selected) => {
                  if (selected.length === 0) {
                    return "Select Region";
                  }
                  return (
                    <Box
                      sx={{ flexWrap: "wrap", gap: 0.5, overflowX: "hidden" }}
                    >
                      {selected?.map((value, i) => (
                        <Chip
                          sx={{ marginRight: "10px" }}
                          key={i}
                          label={value.siteName}
                        />
                      ))}
                    </Box>
                  );
                }}
                MenuProps={{
                  ref: menuListRef,
                  PaperProps: MenuProps.PaperProps,
                }
                }
              >
                <MenuItem
                  value="selectAll"
                  hidden={
                    BusinessUnitSites
                      ? BusinessUnitSites.filter(
                        (bus) => bus.isSelected != true
                      )?.length === 0
                      : true
                  }
                // onClick={handleSelectAllClicked}
                >
                  <Checkbox
                    checked={selectAllChecked}
                  // onChange={handleSelectAllChange}
                  />
                  <ListItemText primary="Select All" />
                </MenuItem>
                {BusinessUnitSites?.map((name, i) => (
                  <MenuItem
                    key={i}
                    value={name}
                    hidden={name.isSelected === true}
                    title={name.siteName}
                  >
                    <Checkbox checked={Regions.includes(name)} />
                    <ListItemText primary={name.siteName} />
                  </MenuItem>
                ))}
              </Select>
            ) : (
              <Select
                sx={{
                  "& legend": { display: "none" },
                  "& fieldset": { top: 0 },
                  width: "320px",
                }}
                labelId="demo-multiple-name-label"
                id="demo-multiple-name"
                size="small"
                value={EditRegionsId || ""}
                onChange={(e) => RegionshandleEditChanged(e.target.value)}
                MenuProps={MenuProps}
              >
                {BusinessUnitSites?.map((item, index) => (
                  <MenuItem key={index} value={item.businessUnitSiteId}>
                    {item.siteName}
                  </MenuItem>
                ))}
              </Select>
            )}
          </>
        )}
        <div>
          <span className="" style={{ color: "#3E4A62" }}>
            Comments
          </span>
          <br />
          <TextareaAutosize
            className="form-control"
            sx={{
              "& legend": { display: "none" },
              "& fieldset": { top: 0 },
              width: "320px",
            }}
            value={Comment || ""}
            onChange={(e) => CommentHandle(e.target.value)}
            aria-label="empty textarea"
            placeholder="Comments"
            style={{ width: 320 }}
          />
          <Typography className="text-danger mx-2 mt-1">
            {/* {errors.email?.message} */}
          </Typography>
        </div>
      </div>

      <DialogActions>
        <div className="login-help__buttonContainer mt-4">
          <Button
            variant="contained"
            className="login-help-button-cancel mx-2"
            onClick={() => {
              Close();
              setDis(false);
            }}
          >
            Cancel
          </Button>
          <Backdrop
            sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
            open={Dis}
          >
            <CircularProgress color="inherit" />
          </Backdrop>
          <Button
            variant="contained"
            className="login-button-request mx-2"
            disabled={Dis}
            onClick={AddLocation}
          >
            {ID == 1 ? "Add" : "Save"}
          </Button>
        </div>
      </DialogActions>
    </div>
  );
}
